export default __webpack_public_path__ + "static/media/bgVideo.34e9a6e0.mp4";